/**
 * Re-entry guard for the telemetry code: while a ring push or a stream send runs,
 * `inTelemetry()` is true, and the console capture (services/consoleCapture.js)
 * records nothing, so a log line from inside telemetry never feeds back into it.
 */
let depth = 0;

/** Whether telemetry code is on the stack. */
export function inTelemetry() {
  return depth > 0;
}

/** Run `fn` with the guard held. */
export function guarded(fn) {
  depth += 1;
  try {
    return fn();
  } finally {
    depth -= 1;
  }
}
